module.exports = __webpack_public_path__ + "img/emoji-neutral.86cbbe0d.svg";